import { forwardRef } from "react";

export type LogoProps = {
  type?: "icon" | "mark" | "default";
  className?: string;
};

export const Logo = forwardRef<SVGSVGElement, LogoProps>(
  ({ type = "default", className }, ref) => {
    if (type === "mark") {
      return (
        <svg ref={ref} viewBox="5 5 14 14" aria-labelledby="matchi-logo" className={className}>
          <title id="matchi-logo">MATCHi</title>
          <path
            d="M15.115 12.577v3.98c0 .693.52 1.27 1.212 1.27h.23a1.301 1.301 0 0 0 1.04-1.27V8.77l-2.482 3.808ZM16.385 6.23h-.289c-.461 0-.865.232-1.096.635l-3.058 4.962-3-4.962c-.23-.403-.634-.634-1.154-.634H7.5c-.577 0-1.038.404-1.212.923-.057.173-.057.404-.057.577v8.827c0 .692.519 1.211 1.211 1.211h.173c.635-.115 1.097-.634 1.097-1.269v-5.596l2.134 3.288c.289.577.98.808 1.558.52.23-.116.404-.289.52-.52l4.614-7.096c-.173-.52-.634-.865-1.153-.865Z"
            fill="#22AD5C"
          />
        </svg>
      );
    }

    if (type === "icon") {
      return (
        <svg
          ref={ref}
          viewBox="0 0 24 24"
          aria-labelledby="matchi-logo"
          className={className}
        >
          <title id="matchi-logo">MATCHi</title>
          <path
            d="M0 3.692A3.692 3.692 0 0 1 3.692 0h16.616A3.692 3.692 0 0 1 24 3.692v16.616A3.692 3.692 0 0 1 20.308 24H3.692A3.692 3.692 0 0 1 0 20.308V3.692Z"
            fill="#22AD5C"
          />
          <path
            d="M15.115 12.577v3.98c0 .693.52 1.27 1.212 1.27h.23a1.301 1.301 0 0 0 1.04-1.27V8.77l-2.482 3.808ZM16.385 6.23h-.289c-.461 0-.865.232-1.096.635l-3.058 4.962-3-4.962c-.23-.403-.634-.634-1.154-.634H7.5c-.577 0-1.038.404-1.212.923-.057.173-.057.404-.057.577v8.827c0 .692.519 1.211 1.211 1.211h.173c.635-.115 1.097-.634 1.097-1.269v-5.596l2.134 3.288c.289.577.98.808 1.558.52.23-.116.404-.289.52-.52l4.614-7.096c-.173-.52-.634-.865-1.153-.865Z"
            fill="#fff"
          />
        </svg>
      );
    }

    return (
      <svg
        ref={ref}
        viewBox="0 0 77 16"
        aria-labelledby="matchi-logo"
        className={className}
      >
        <title id="matchi-logo">MATCHi</title>
        <path
          d="M13.437 0h.364c.768 0 1.418.518 1.633 1.228l-6.288 9.85c-.353.54-.798.877-1.415.877-.618 0-1.063-.337-1.416-.877L3.37 6.46v7.782c0 .857-.681 1.666-1.52 1.748A1.666 1.666 0 0 1 0 14.312V2.065c0-.337.017-.645.064-.792A1.708 1.708 0 0 1 1.707 0h.448c.726 0 1.235.382 1.543.902l4.097 6.83L11.915.88c.354-.586.838-.88 1.522-.88ZM12.135 14.266V7.977l3.37-5.284v11.528c0 .84-.567 1.595-1.379 1.75-1.065.204-1.99-.653-1.99-1.705ZM41.657 3.22c.867 0 1.582-.725 1.582-1.61 0-.886-.712-1.61-1.582-1.61H31.632c-.87 0-1.583.724-1.583 1.61 0 .885.712 1.61 1.583 1.61h3.298v4.523h3.431V3.219h3.296ZM34.93 14.255c0 .973.756 1.745 1.715 1.745.96 0 1.716-.77 1.716-1.745V8.752H34.93v5.503ZM50.63 3.137c1.196 0 2.172.4 3.106 1.106.24.156.543.331.999.331.912 0 1.651-.73 1.651-1.657 0-.597-.303-1.084-.65-1.35C54.476.62 52.933 0 50.652 0c-4.577 0-7.797 3.463-7.922 7.74h3.495c.098-2.552 1.913-4.603 4.405-4.603ZM54.932 11.273c-.392 0-.74.156-.998.376-.957.773-1.891 1.217-3.304 1.217-2.355 0-4.054-1.805-4.36-4.11h-3.518c.334 4.101 3.534 7.247 7.77 7.247 2.433 0 4.04-.73 5.408-1.946.303-.266.565-.685.565-1.217 0-.863-.718-1.57-1.566-1.57l.003.003ZM61.45 1.731V6.36l.003.003h2.72v3.191h-2.72v4.719c0 .967-.75 1.73-1.702 1.73-.95 0-1.702-.763-1.702-1.73V1.732C58.05.763 58.8 0 59.751 0c.948 0 1.7.764 1.7 1.731ZM67.724 1.731c0-.967.75-1.731 1.702-1.731.95 0 1.701.764 1.701 1.731V14.27c0 .967-.75 1.731-1.701 1.731-.951 0-1.702-.764-1.702-1.731V9.55h-2.559V6.36h2.559V1.73ZM76.464 1.904c0-1.08-.887-1.952-1.96-1.901-1.007.048-1.78.93-1.78 1.955v1.85h1.871c1.035 0 1.872-.852 1.872-1.904h-.003ZM72.72 14.272c0 .967.752 1.73 1.703 1.73.95 0 1.702-.763 1.702-1.73V4.82h-3.401v9.452h-.003ZM26.61 1.36l5.353 12.298v.003c.108.243.197.489.197.735 0 .894-.678 1.607-1.557 1.607-.701 0-1.271-.402-1.558-1.072l-.914-2.187-3.538-8.569-2.127 5.155h3.27l1.255 3.035h-5.776l-1.032 2.455c-.309.713-.834 1.183-1.624 1.183-.9 0-1.602-.739-1.602-1.652 0-.224.067-.447.175-.693L22.486 1.36C22.858.512 23.517 0 24.438 0h.197c.92 0 1.602.512 1.974 1.36Z"
          fill="#22AD5C"
        />
      </svg>
    );
  },
);

Logo.displayName = "Logo";
